import  {enableDisableFilters,  resetHighlightSections,  resetPackageType, highlightSections } from '../shared/seating_chart_filter'
import PriceFilter from '../shared/price_filter.vue'
import VueLoader from '../default/vue-loader'

let pkg_types = []

let checker = (categories, pkg_types) => pkg_types.every(pkg_type => categories.includes(pkg_type))

const addVueListener = function() {
  VueLoader.loadVueComponent(PriceFilter, document.getElementById('seating_chart_price'))
}

const hideAllPackages = () => {
  $('.rigtside .product-item').each(function () {
    $(this).parent().addClass('pkg-hidden')
  })
}

const disableSections = () => {
  Array.from(document.querySelectorAll('.leftsidemap [data-toggle=svg-tooltip]')).forEach((elem) => {
    $(elem).css('fill', '#ccc')
    $(elem).addClass('disableClick')
  })
}

const filterPackagesRangeSlider = (minVal, maxVal) => {
  hideAllPackages()
  disableSections()

  Array.from(document.querySelectorAll('.product-item')).forEach( (elem) => {
    let categories = elem.getAttribute('data-category-names').split(',')
    let price = parseInt(elem.getAttribute('data-price'))

    if(checker(categories, pkg_types) && (minVal <= price && maxVal >= price)) {
      highlightSections(elem)
      elem.parentElement.classList.remove('pkg-hidden')
    }
  })
}

const showHideFiltersSlide = () => {
  if($('.filters_wrapper').hasClass('display')) {
    $('.filters_wrapper').addClass('closed')
    $('.filters_wrapper').removeClass('display')
  } else {
    $('.filters_wrapper').removeClass('closed')
    $('.filters_wrapper').addClass('display')
  }

  $('.packageaccess').toggleClass('hide')
  $('.filter-heading .filter').toggleClass('show')
  $('.filter-heading').toggleClass('show')
}

const filterPackages = (pkg_types) => {
  Array.from(document.querySelectorAll('.product-item')).forEach( (elem) => {
    let categories = elem.getAttribute('data-category-names').split(',')
    if(checker(categories, pkg_types)) {
      highlightSections(elem)
      elem.parentElement.classList.remove('pkg-hidden')
    }
  })
}

$(document)
  .on('click', '.filter-heading .filter', function () {
    showHideFiltersSlide()
  })

  .on('click', '.divoclose .closebtn', function () {
    showHideFiltersSlide()
  })

  .on('change', '.slider__min-slider', function () {
    $('.min-slider').blur()
    $('.max-slider').blur()

    const minVal = parseInt($(this).val())
    const maxVal = parseInt($('.slider__max-slider').val())

    filterPackagesRangeSlider(minVal, maxVal)
  })

  .on('keyup', '.min-slider', function (event) {
    if (event.keyCode == 13) {
      const minVal = parseInt($(this).val().slice(1))
      const maxVal = parseInt($('.slider__max-slider').val())
      $('.min-slider').blur()
      $('.max-slider').blur()

      filterPackagesRangeSlider(minVal, maxVal)
    }
  })

  .on('change', '.slider__max-slider', function () {
    $('.min-slider').blur()
    $('.max-slider').blur()

    const minVal = parseInt($('.slider__min-slider').val())
    const maxVal = parseInt($(this).val())

    filterPackagesRangeSlider(minVal, maxVal)
  })

  .on('keyup', '.max-slider', function (event) {
    if (event.keyCode == 13) {
      const minVal = parseInt($('.slider__min-slider').val())
      const maxVal = parseInt($(this).val().slice(1))
      $('.min-slider').blur()
      $('.max-slider').blur()

      filterPackagesRangeSlider(minVal, maxVal)
    }
  })

  .on('change', '.divoclose input[type=checkbox]', function () {
    pkg_types = []
    let data_categories = []
    $('.divoclose .navfilter li[data-filter]').each(function () {
      let pkg_type = $(this).attr('data-filter')
      if (pkg_type) {
        let isChecked = $(this).find('input[type=checkbox]').is(':checked')
        if (isChecked) {
          pkg_types.push(pkg_type)
        } else {
          let index = pkg_types.indexOf(pkg_type)
          if (index > 0) {
            pkg_types.splice(index, 1)
          }
        }
      }
      pkg_types = Array.from(new Set(pkg_types))

    })
    if (pkg_types.length == 0) {
      resetPackageType()
      resetHighlightSections()
      enableDisableFilters(data_categories)
      addVueListener()
    } else {
      hideAllPackages()
      disableSections()
      filterPackages(pkg_types)
      Array.from(document.querySelectorAll('.product-item')).forEach( (elem) => {
        if(!($(elem).parent().hasClass('pkg-hidden'))) {
          let categories = elem.getAttribute('data-category-names').split(',')
          data_categories.push(categories)
        }
      })
      data_categories = data_categories.flat()
      data_categories = Array.from(new Set(data_categories))

      enableDisableFilters(data_categories)
      addVueListener()
    }
  })

document.addEventListener('turbo:load', () => {
  addVueListener()
})
